export enum GGAnalyticsEvents {
    // =========== General Screen load Events =============
    AUTH_PAGE_LOADED = "AUTH_PAGE_LOADED", // For our login and registration page
    LANDING_PAGE_LOADED = "LANDING_PAGE_LOADED", // Our main landing page
    TERMS_OF_SERVICE_PAGE_LOADED = "TERMS_OF_SERVICE_PAGE_LOADED", // Event for Terms of Service page
    PRIVACY_POLICY_PAGE_LOADED = "PRIVACY_POLICY_PAGE_LOADED", // Event for Privacy Policy page
    ABOUT_US_PAGE_LOADED = "ABOUT_US_PAGE_LOADED", // Event for About Us page load
    CONTACT_US_PAGE_LOADED = "CONTACT_US_PAGE_LOADED", // Event for Contact Us page
    FAQS_PAGE_LOADED = "FAQS_PAGE_LOADED", // Event for FAQs page
    BECOME_A_SELLER_PAGE_LOADED = "BECOME_A_SELLER_PAGE_LOADED", // Event for Become a Freelancer page
    CATEGORIES_PAGE_LOADED = "CATEGORIES_PAGE_LOADED",
    GIG_LIST_PAGE_LOADED = "GIG_LIST_PAGE_LOADED",
    GIG_INFO_PAGE_LOADED = "GIG_INFO_PAGE_LOADED",
    PUBLIC_PROFILE_PAGE_LOADED = "PUBLIC_PROFILE_PAGE_LOADED",

    SELLER_REGISTRATION_PAGE_LOADED = "SELLER_REGISTRATION_PAGE_LOADED",
    SELLER_DASHBOARD_PAGE_LOADED = "SELLER_DASHBOARD_PAGE_LOADED", // Event for Freelancer Dashboard page
    MY_PROFILE_PAGE_LOADED = "MY_PROFILE_PAGE_LOADED",
    MY_MESSAGES_PAGE_LOADED = "MY_MESSAGES_PAGE_LOADED", // When chat page is opened without going through freelancer dashboard
    CREATE_ORDER_PAGE_LOADED = "CREATE_ORDER_PAGE_LOADED", // Order placement page - aka checkout confirmation page as well
    BUYER_ORDERS_PAGE_LOADED = "BUYER_ORDERS_PAGE_LOADED",
    PAYMENT_SUCCESS_PAGE_LOADED = "PAYMENT_SUCCESS_PAGE_LOADED",
    PAYMENT_FAILURE_PAGE_LOADED = "PAYMENT_FAILURE_PAGE_LOADED",
    BUYER_ORDER_DETAILS_PAGE_LOADED = "BUYER_ORDER_DETAILS_PAGE_LOADED",
    
    ADD_NEW_GIG_PAGE_LOADED = "ADD_NEW_GIG_PAGE_LOADED",
    EDIT_GIG_PAGE_LOADED = "EDIT_GIG_PAGE_LOADED",
    SELLER_PROFILE_EDIT_PAGE_LOADED = "SELLER_PROFILE_EDIT_PAGE_LOADED",


    // =========== User Action Events =============
    SELLER_REGISTRATION_CONGRATULATIONS_SHOWN = "SELLER_REGISTRATION_CONGRATULATIONS_SHOWN",
}